import AccountHolder from './AccountHolderContainer';


export default AccountHolder;